import React, { SetStateAction, useState, Dispatch, ReactNode } from 'react';
import styled from 'styled-components';
import { IoMdArrowDropdown } from 'react-icons/io';
import { IoMdArrowDropup } from 'react-icons/io';
import { FaCheck } from 'react-icons/fa';

type itemsProps = Array<{key: string, value: string}>;

type SelectComponentProps = {
  label: string
  selectItemsState: Array<string>
  setSelectItemsAction: Dispatch<SetStateAction<Array<string>>>
  items: itemsProps
  icon?: ReactNode
}

const SelectStyle = styled.div`
position: relative;
  color: #393432;
  width: 100%;

  ul {
    position: absolute;
    background: #fafafa;
    border: 1px solid #e6e4dc;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: 12px;
    z-index: 9999;
    margin: 10px 0 0 0;
    padding: 0;
    width: inherit;

    li {
      padding: 4px 10px;
      list-style: none;

      &:hover {
        cursor: pointer;
        background: #f2f0e9;
      }

      span {
        margin-left: 5px;
      }
    }
  }
`;

const SelectButtonStyle = styled.div`
  display: flex;
  align-items: center;
  background: #f2f0e9;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-size: 14px;
  justify-content: space-around;
  width: inherit;
  height: 50px;

  &:hover {
    background: #696767;
    color: white;
  }
`;

const LabelLeftStyle = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: 5px;
  }
`;

const LabelRightStyle = styled.div`
  display: flex;
`;

const MultipleSelect: React.FC<SelectComponentProps> = ({ label, selectItemsState, setSelectItemsAction, items, icon }) => {
  const [open, setOpen] = useState<boolean>(false);
  // const [selectItems, setSelectItems] = useState<Array<string>>([]);

  const SelectList = (items: itemsProps) => {
    return (
      <ul>
        {items.map(item => {
          return <li key={item.key} onClick={() => {
            if (selectItemsState.includes(item.key)) {
              setSelectItemsAction(selectItemsState.filter(selectItem => selectItem !== item.key));
            } else {
              setSelectItemsAction(selectItemsState.concat(item.key));
            }
          }}>
            { item.value }
            {selectItemsState.includes(item.key) && <span><FaCheck /></span>}
            </li>;
        })}
      </ul>
    );
  };

  return (
    <SelectStyle>
      <SelectButtonStyle onClick={() => setOpen(!open)}>
        <LabelLeftStyle>
          { icon }
          { label }
        </LabelLeftStyle>
        <LabelRightStyle>
          { open ? <IoMdArrowDropup /> : <IoMdArrowDropdown />}
        </LabelRightStyle>
      </SelectButtonStyle>
      { open && SelectList(items) }
    </SelectStyle>
  );
};

export default MultipleSelect;
